import React from 'react';
import { Heart, ZoomOut } from 'lucide-react';

export const MAP_EMPTY_COPY = {
  title: 'No love nearby yet',
  body: 'Zoom out to discover positive spots, or be the first to leave a review!',
};

interface MapAreaEmptyStateProps {
  canZoomOut?: boolean;
  onZoomOut?: () => void;
  onLeaveReview?: () => void;
}

/**
 * Sidebar empty state when the visible map area has no positive businesses.
 */
const MapAreaEmptyState: React.FC<MapAreaEmptyStateProps> = ({
  canZoomOut = true,
  onZoomOut,
  onLeaveReview,
}) => {
  return (
    <div className="text-center">
      <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <Heart className="w-8 h-8 text-primary-600" />
      </div>

      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {MAP_EMPTY_COPY.title}
      </h3>
      <p className="text-gray-600 text-sm mb-5">
        {MAP_EMPTY_COPY.body}
      </p>

      <div className="flex flex-col sm:flex-row gap-2 justify-center">
        {canZoomOut && onZoomOut && (
          <button
            type="button"
            onClick={onZoomOut}
            className="inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg bg-primary-600 hover:bg-primary-700 text-white transition-colors"
          >
            <ZoomOut className="w-4 h-4" />
            Zoom out
          </button>
        )}
        {onLeaveReview && (
          <button
            type="button"
            onClick={onLeaveReview}
            className="inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg bg-accent-600 hover:bg-accent-700 text-white transition-colors"
          >
            <Heart className="w-4 h-4 fill-current" />
            Leave a Review
          </button>
        )}
      </div>
    </div>
  );
};

export default MapAreaEmptyState;
